import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";

import MomentsUser from "../../components/MomentsUser";
// import MomentsQueues from "../../components/MomentsQueues";

import MainHeader from "../../components/MainHeader";
import { Grid, Paper } from "@material-ui/core";
import Title from "../../components/Title";
import ForbiddenPage from "../../components/ForbiddenPage";
import { AuthContext } from "../../context/Auth/AuthContext";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: "5px",
    maxWidth: "100%",
  },
  mainPaper: {
    display: "flex",
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    alignItems: "center",
    backgroundColor: theme.palette.fancyBackground,
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 100,
  },
  chatPapper: {
    display: "flex",
    height: "100%",
  },
  contactsHeader: {
    display: "flex",
    flexWrap: "wrap",
    padding: "0px 6px 6px 6px",
  },
}));

const ChatMoments = ({ embedded = false }) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);

  if (user.allowRealTime !== "enabled") {
    return <ForbiddenPage />;
  }

  const content = (
    <Grid
      style={{ width: "99.6%" }}
      container
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid xs={12} item style={{ textAlign: "center" }}>
        <Title>{i18n.t("servicePanel.allowRealTime")}</Title>
      </Grid>
      <Grid style={{ width: "100%", height: "100vh" }} item>
        <Paper
          className={classes.mainPaper}
          variant="outlined"
          style={{ maxWidth: "100%" }}
        >
          <MomentsUser />
        </Paper>
      </Grid>
    </Grid>
  );

  return embedded ? content : <MainHeader>{content}</MainHeader>;
};

export default ChatMoments;
